import { useCallback, useEffect, useLayoutEffect, useRef, useState } from "react";

import { Tooltip } from "antd";

export const TaskTruncatedCell = ({
  text,
  className,
  testId,
  showTooltip = false,
}) => {
  const cellRef = useRef(null);
  const [isTruncated, setIsTruncated] = useState(false);

  const measureTruncation = useCallback(() => {
    const element = cellRef.current;
    if (!element) {
      setIsTruncated(false);
      return;
    }

    setIsTruncated(element.scrollWidth > element.clientWidth);
  }, []);

  useLayoutEffect(() => {
    measureTruncation();
  }, [text, measureTruncation]);

  useEffect(() => {
    const element = cellRef.current;
    if (!element || typeof ResizeObserver === "undefined") {
      return undefined;
    }

    const observer = new ResizeObserver(measureTruncation);
    observer.observe(element);
    return () => observer.disconnect();
  }, [measureTruncation]);

  const cell = (
    <span ref={cellRef} className={className} data-testid={testId}>
      {text}
    </span>
  );

  if (!showTooltip || !isTruncated) {
    return cell;
  }

  return (
    <Tooltip title={text} placement="topLeft">
      {cell}
    </Tooltip>
  );
};
